import { useContext, useEffect } from "react";
import AuthContext from "../../../context/AuthContext";
import useCustomForm from "../../../hooks/useCustomForm";
import "../UserAccess.css";
import LoginFormContent from "./FormContent";
import AccessContainer from "../AccessContainer";

const LoginContent = () => {
  const { loginUser, isServerError } = useContext(AuthContext);
  const defaultValues = { username: "", password: "" };
  const [formData, handleInputChange, handleSubmit, reset, loading] =
    useCustomForm(defaultValues, loginUser);

  useEffect(() => {
    if (isServerError) {
      reset();
    }
     // eslint-disable-next-line
  }, [isServerError]);

  return (
    <AccessContainer>
      <LoginFormContent
        formData={formData}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
        loading={loading}
      />
    </AccessContainer>
  );
};

export default LoginContent;
